import React, { Component } from 'react';

export class BlogEntry extends Component {
    render() {
        return (
            <h1>Blog Entry</h1>
        );
    }
}